function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zm0-2c3.156 0 6-2.844 6-6s-2.844-6-6-6-6 2.844-6 6 2.844 6 6 6z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 4.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v2.8a.5.5 0 00.179.384l1.379 1.157a.5.5 0 01.062.704l-.644.767a.5.5 0 01-.704.062L7.18 8.62A.5.5 0 017 8.237V4.5z"
});

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgClock;